/* Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. */

angular.module('ticketspaceApp').directive('dropdownMenu', DropDownMenuDirective);

function DropDownMenuDirective() {
	return {
		transclude: {
			title: 'menuToggle',
			body: 'menuContent',
		},
		controllerAs: '$ctrl',
		scope: true,
		template: require('html-loader?root=src/!tpl/directive/dropdown-menu.html'),
		link(scope, element, attrs, ctrl, transclude) {
			const titleNode = element.find('[ng-click="$ctrl.toggle(); $whenOpened()"]');
			const bodyNode = element.find('.drop-down-menu');
			transclude(
				scope,
				function (content) {
					titleNode.append(content);
				},
				null,
				'title'
			);

			transclude(
				scope,
				function (content) {
					bodyNode.append(content);
				},
				null,
				'body'
			);
		},
		controller() {
			this.opened = false;
			this.toggle = function () {
				this.opened = !this.opened;
			};
		},
	};
}
